import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import { isValidMobile } from '@/utils/validate';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.validateMobileNumber = (rule, value, callback) => {
      if (!isValidMobile(value)) {
        callback(new Error('Please enter valid mobile number'));
      } else {
        callback();
      }
    };
    this.step = 'request';
    this.hash = '';
    this.countdown = 0;
    this.countdownTimer = null;
    // 4-digit OTP entry state
    this.otpDigits = ['', '', '', ''];
    this.otpError = '';
    this.loginForm = {
      mobileNumber: '',
      otp: ''
    };
    this.loginRules = {
      mobileNumber: [{
        validator: this.validateMobileNumber,
        trigger: 'blur'
      }],
      otp: [{
        required: true,
        message: 'Please enter OTP',
        trigger: 'blur'
      }]
    };
    this.loading = false;
    this.otherQuery = {};
  }
  onRouteChange(route) {
    const query = route.query;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }
  mounted() {
    if (this.loginForm.mobileNumber === '') {
      var _this$$refs$mobileNum;
      (_this$$refs$mobileNum = this.$refs.mobileNumber) === null || _this$$refs$mobileNum === void 0 || _this$$refs$mobileNum.focus();
    }
  }
  startCountdown() {
    this.countdown = 60;
    if (this.countdownTimer) clearInterval(this.countdownTimer);
    this.countdownTimer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownTimer);
      }
    }, 1000);
  }
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  }
  resetOtpBoxes() {
    this.otpDigits = ['', '', '', ''];
    this.otpError = '';
    this.loginForm.otp = '';
  }
  backToRequest() {
    this.step = 'request';
    this.resetOtpBoxes();
    this.$nextTick(() => {
      var _this$$refs$mobileNum2;
      (_this$$refs$mobileNum2 = this.$refs.mobileNumber) === null || _this$$refs$mobileNum2 === void 0 || _this$$refs$mobileNum2.focus();
    });
  }
  // --- OTP box handling ---
  focusOtpBox(index) {
    var _this$$refs$refName;
    const refName = 'otpBox' + index;
    const el = (_this$$refs$refName = this.$refs[refName]) === null || _this$$refs$refName === void 0 ? void 0 : _this$$refs$refName[0];
    if (el) {
      el.focus();
      el.select();
    }
  }
  onOtpInput(index, event) {
    const raw = event.target.value || '';
    // keep only the last typed digit, numeric only
    const digit = raw.replace(/[^0-9]/g, '').slice(-1);
    this.$set(this.otpDigits, index, digit);
    this.otpError = '';
    this.syncOtpToForm();
    if (digit && index < this.otpDigits.length - 1) {
      this.focusOtpBox(index + 1);
    }
    if (this.otpDigits.every(d => d !== '') && this.loginForm.otp.length === 4) {
      this.$nextTick(() => this.handleVerifyOtp());
    }
  }
  onOtpKeydown(index, event) {
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      this.focusOtpBox(index - 1);
    } else if (event.key === 'ArrowLeft' && index > 0) {
      this.focusOtpBox(index - 1);
    } else if (event.key === 'ArrowRight' && index < this.otpDigits.length - 1) {
      this.focusOtpBox(index + 1);
    }
  }
  onOtpPaste(event) {
    var _event$clipboardData;
    const pasted = ((_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text')) || '';
    const digits = pasted.replace(/[^0-9]/g, '').slice(0, 4).split('');
    if (digits.length) {
      event.preventDefault();
      digits.forEach((d, i) => this.$set(this.otpDigits, i, d));
      this.syncOtpToForm();
      const nextEmpty = digits.length < 4 ? digits.length : 3;
      this.focusOtpBox(nextEmpty);
      if (digits.length === 4) {
        this.$nextTick(() => this.handleVerifyOtp());
      }
    }
  }
  syncOtpToForm() {
    this.loginForm.otp = this.otpDigits.join('');
  }
  // --- API calls ---
  async handleRequestOtp() {
    if (!isValidMobile(this.loginForm.mobileNumber)) {
      this.$message.error('Please enter a valid 10-digit mobile number');
      return;
    }
    this.loading = true;
    try {
      const response = await AdminModule.AgentRequestOtp(this.loginForm.mobileNumber);
      const {
        hash,
        otpSent
      } = response.otp;
      if (otpSent) {
        this.hash = hash;
        this.step = 'verify';
        this.resetOtpBoxes();
        this.startCountdown();
        this.$nextTick(() => {
          this.focusOtpBox(0);
        });
      } else {
        this.$message.error('Failed to send OTP');
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$message.error(error.message || 'Error requesting OTP');
    }
  }
  async resendOtp() {
    this.loading = true;
    try {
      const response = await AdminModule.AgentRequestOtp(this.loginForm.mobileNumber);
      const {
        hash,
        otpSent
      } = response.otp;
      if (otpSent) {
        this.hash = hash;
        this.resetOtpBoxes();
        this.startCountdown();
        this.$message.success('OTP resent successfully');
        this.$nextTick(() => this.focusOtpBox(0));
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
  async handleVerifyOtp() {
    this.syncOtpToForm();
    if (!this.loginForm.otp || this.loginForm.otp.length !== 4) {
      this.otpError = 'Please enter the 4-digit OTP';
      return;
    }
    this.loading = true;
    try {
      const response = await AdminModule.AgentVerifyOtp({
        mobileNumber: this.loginForm.mobileNumber,
        hash: this.hash,
        otp: this.loginForm.otp
      });
      let finalRedirect = this.redirect || '/';
      if (finalRedirect === '/agent-login') finalRedirect = '/dashboard';
      this.$router.push({
        path: finalRedirect,
        query: this.otherQuery
      }).catch(err => {});
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.otpError = error.message || 'Invalid OTP';
    }
  }
  getOtherQuery(query) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur];
      }
      return acc;
    }, {});
  }
};
__decorate([Watch('$route', {
  immediate: true
})], default_1.prototype, "onRouteChange", null);
default_1 = __decorate([Component({
  name: 'Login'
})], default_1);
export default default_1;